export enum AlpsStatus {
  Initial = 'INITIAL',
  ContraParty = 'CONTRA_PARTY',
  Nscc = 'NSCC',
  Finished = 'FINISHED',
  RequestAlpsApproval = 'REQUEST_ALPS_APPROVAL',
  RequestMarginsApproval = 'REQUEST_MARGINS_APPROVAL',
  Settling = 'SETTLING',
  CreateSweepingRequest = 'CREATE_SWEEPING_REQUEST',
  Invalid = 'INVALID',
  CreateRequest = 'CREATE_REQUEST',
  RequestError = 'REQUEST_ERROR',
  ReviewAlpsApproval = 'REVIEW_ALPS_APPROVAL',
  ReviewError = 'REVIEW_ERROR',
  ReviewMarginApproval = 'REVIEW_MARGIN_APPROVAL',
  RequestContraPartyApproval = 'REQUEST_CONTRA_PARTY_APPROVAL',
  Error = 'ERROR',
  TransferComplete = 'TRANSFER_COMPLETE',
  RegisteringFunds = 'REGISTERING_FUNDS',
}

// eslint-disable-next-line
export const AlpsStatusDisplay: { [key in AlpsStatus]: string } = {
  [AlpsStatus.Initial]: 'Initial',
  [AlpsStatus.ContraParty]: 'ContraParty',
  [AlpsStatus.Nscc]: 'Nscc',
  [AlpsStatus.Finished]: 'Finished',
  [AlpsStatus.RequestAlpsApproval]: 'Request Alps Approval',
  [AlpsStatus.RequestMarginsApproval]: 'Request Margins Approval',
  [AlpsStatus.Settling]: 'Settling',
  [AlpsStatus.CreateSweepingRequest]: 'Create Sweeping Request',
  [AlpsStatus.Invalid]: 'Invalid Legacy',
  [AlpsStatus.CreateRequest]: 'Create Request',
  [AlpsStatus.RequestError]: 'Request Error',
  [AlpsStatus.ReviewAlpsApproval]: 'Review Alps Approval',
  [AlpsStatus.ReviewError]: 'Review Error',
  [AlpsStatus.ReviewMarginApproval]: 'Review Margin Approval',
  [AlpsStatus.RequestContraPartyApproval]: 'Contra Party Approval',
  [AlpsStatus.Error]: 'Error',
  [AlpsStatus.TransferComplete]: 'Complete',
  [AlpsStatus.RegisteringFunds]: 'Registering Funds',
}

export enum NsccStatus {
  Request = 'REQUEST',
  RequestAdjust = 'REQUEST_ADJUST',
  RequestAdjustPast = 'REQUEST_ADJUST_PAST',
  RequestPast = 'REQUEST_PAST',
  RequestReject = 'REQUEST_REJECT',
  Review = 'REVIEW',
  ReviewAdjustDeliverer = 'REVIEW_ADJUST_DELIVERER',
  ReviewError = 'REVIEW_ERROR',
  ReviewAccelerate = 'REVIEW_ACCELERATE',
  ReviewAdjustReceiverAccelerate = 'REVIEW_ADJUST_RECEIVER_ACCELERATE',
  SettleClose = 'SETTLE_CLOSE',
  ClosePurge = 'CLOSE_PURGE',
  MemoPurgePartialTransferRequestReceiver = 'MEMO_PURGE_PARTIAL_TRANSFER_REQUEST_RECEIVER',
  Reject = 'REJECT',
  SystemPurge = 'SYSTEM_PURGE',
  Undefined = 'UNDEFINED',
  PartialRequest = 'PARTIAL_REQUEST',
}

// eslint-disable-next-line
export const NsccStatusDisplay: { [key in NsccStatus]: string } = {
  [NsccStatus.Request]: 'Request',
  [NsccStatus.RequestAdjust]: 'Request Adjust',
  [NsccStatus.RequestAdjustPast]: 'Request Adjust Past',
  [NsccStatus.RequestPast]: 'Request Past',
  [NsccStatus.RequestReject]: 'Request Reject',
  [NsccStatus.Review]: 'Review',
  [NsccStatus.ReviewAdjustDeliverer]: 'Review Adjust Deliverer',
  [NsccStatus.ReviewError]: 'Review Error',
  [NsccStatus.ReviewAccelerate]: 'Review Accelerate',
  [NsccStatus.ReviewAdjustReceiverAccelerate]:
    'Review Adjust Receiver Accelerate',
  [NsccStatus.SettleClose]: 'Settle Close',
  [NsccStatus.ClosePurge]: 'Close Purge',
  [NsccStatus.MemoPurgePartialTransferRequestReceiver]:
    'Memo Purge-Partial Transfer Request (Receiver)',
  [NsccStatus.Reject]: 'Reject',
  [NsccStatus.SystemPurge]: 'System Purge',
  [NsccStatus.Undefined]: 'Undefined',
  [NsccStatus.PartialRequest]: 'Partial Request',
}

export enum ProcessingDirection {
  Internal = 'INTERNAL',
  Joining = 'JOINING',
  Leaving = 'LEAVING',
}

export const ProcessingDirectionDisplay: {
  // eslint-disable-next-line
  [key in ProcessingDirection]: string
} = {
  [ProcessingDirection.Internal]: 'Internal',
  [ProcessingDirection.Joining]: 'Incoming',
  [ProcessingDirection.Leaving]: 'Outgoing',
}

export enum TransferType {
  FailReversalBrokerToBrokerOnly = 'FAIL_REVERSAL_BROKER_TO_BROKER_ONLY',
  FullTransfer = 'FULL_TRANSFER',
  MutualFundCleanup = 'MUTUAL_FUND_CLEANUP',
  PartialTransferDeliverer = 'PARTIAL_TRANSFER_DELIVERER',
  PartialTransferReceiver = 'PARTIAL_TRANSFER_RECEIVER',
  PositionTransferFundFirmToMutualFundCompanyOnly = 'POSITION_TRANSFER_FUND_FIRM_TO_MUTUAL_FUND_COMPANY_ONLY',
  Reclaim = 'RECLAIM',
  ResidualCredit = 'RESIDUAL_CREDIT',
  Undefined = 'UNDEFINED',
}

//Note the similarity to above TransferType
export enum TransferInitiationTransferType {
  FullTransfer = 'FULL_TRANSFER',
  PartialTransferReceiver = 'PARTIAL_TRANSFER_RECEIVER',
  PositionTransferFundFirmToMutualFundCompanyOnly = 'POSITION_TRANSFER_FUND_FIRM_TO_MUTUAL_FUND_COMPANY_ONLY',
  MutualFundCleanup = 'MUTUAL_FUND_CLEANUP',
  FailReversal = 'FAIL_REVERSAL',
  ResidualCredit = 'RESIDUAL_CREDIT',
  PartialTransferDeliverer = 'PARTIAL_TRANSFER_DELIVERER',
  Reclaim = 'RECLAIM',
}

// eslint-disable-next-line
export const TransferTypeDisplay: { [key in TransferType]: string } = {
  [TransferType.FailReversalBrokerToBrokerOnly]:
    'Fail Reversal (broker to broker only)',
  [TransferType.FullTransfer]: 'Full Transfer',
  [TransferType.MutualFundCleanup]: 'Mutual Fund Cleanup',
  [TransferType.PartialTransferDeliverer]: 'Partial Transfer Deliverer',
  [TransferType.PartialTransferReceiver]: 'Partial Transfer Request (Receiver)',
  [TransferType.PositionTransferFundFirmToMutualFundCompanyOnly]:
    'Position Transfer Fund (Firm to Mutual Fund Company Only)',
  [TransferType.Reclaim]: 'Reclaim',
  [TransferType.ResidualCredit]: 'Residual Credit',
  [TransferType.Undefined]: 'Undefined',
}

export enum RejectReason {
  None = 'NONE',
  SsnTaxId = 'SSN_TAX_ID',
  AccountTitle = 'ACCOUNT_TITLE',
  DocumentationMissing = 'DOCUMENTATION_MISSING',
  AccountFlat = 'ACCOUNT_FLAT',
  AccountNumber = 'ACCOUNT_NUMBER',
  Duplicate = 'DUPLICATE',
  InDistributionOrTransfer = 'IN_DISTRIBUTION_OR_TRANSFER',
  ClientRescinded = 'CLIENT_RESCINDED',
  AuthorizationSignatureMissing = 'AUTHORIZATION_SIGNATURE_MISSING',
  PositionTransferFund = 'POSITION_TRANSFER_FUND',
  CreditPolicyViolation = 'CREDIT_POLICY_VIOLATION',
  RcrReject = 'RCR_REJECT',
  PtdReject = 'PTD_REJECT',
  FrvReject = 'FRV_REJECT',
  RclReject = 'RCL_REJECT',
  MfcReject = 'MFC_REJECT',
  PtfReject = 'PTF_REJECT',
  NsccReject = 'NSCC_REJECT',
}

// eslint-disable-next-line
export const RejectReasonDisplay: { [key in RejectReason]: string } = {
  [RejectReason.None]: 'None',
  [RejectReason.SsnTaxId]: 'SSN Tax id',
  [RejectReason.AccountTitle]: 'Account Title',
  [RejectReason.DocumentationMissing]: 'Documentation Missing',
  [RejectReason.AccountFlat]: 'Account Flat',
  [RejectReason.AccountNumber]: 'Account Number',
  [RejectReason.Duplicate]: 'Duplicate',
  [RejectReason.InDistributionOrTransfer]: 'In Distribution or Transfer',
  [RejectReason.ClientRescinded]: 'Client Rescinded',
  [RejectReason.AuthorizationSignatureMissing]:
    'Authorization Signature Missing',
  [RejectReason.PositionTransferFund]: 'Position Transfer Fund',
  [RejectReason.CreditPolicyViolation]: 'Credit Policy Violation',
  [RejectReason.RcrReject]: 'RCR Reject',
  [RejectReason.PtdReject]: 'PTD Reject',
  [RejectReason.FrvReject]: 'FRV Reject',
  [RejectReason.RclReject]: 'RCL Reject',
  [RejectReason.MfcReject]: 'MFC Reject',
  [RejectReason.PtfReject]: 'PTF Reject',
  [RejectReason.NsccReject]: 'NSCC Reject',
}

export enum AlpsRecommendedAction {
  None = 'NONE',
  AcceptAssets = 'ACCEPT_ASSETS',
  AttachAssets = 'ATTACH_ASSETS',
  Reject = 'REJECT',
  Resubmit = 'RESUBMIT',
  InitiateTransfer = 'INITIATE_TRANSFER',
  AddAsset = 'ADD_ASSET',
  DeleteAsset = 'DELETE_ASSET',
  AdjustAsset = 'ADJUST_ASSET',
  Purge = 'PURGE',
  RejectSsnTaxIdMismatch = 'REJECT_SSN_TAX_ID_MISMATCH',
  RejectAccountTitleMismatch = 'REJECT_ACCOUNT_TITLE_MISMATCH',
  RejectDocumentationNeeded = 'REJECT_DOCUMENTATION_NEEDED',
  RejectAccountFlat = 'REJECT_ACCOUNT_FLAT',
  RejectInvalidAccountNumber = 'REJECT_INVALID_ACCOUNT_NUMBER',
  RejectDuplicate = 'REJECT_DUPLICATE',
  RejectAccountInDistrubutionOrTransfer = 'REJECT_ACCOUNT_IN_DISTRIBUTION_OR_TRANSFER',
  RejectClientRescinded = 'REJECT_CLIENT_RESCINDED',
  RejectMissingAuthorizationSignature = 'REJECT_MISSING_AUTHORIZATION_SIGNATURE',
  RejectCreditPolicyViolation = 'REJECT_CREDIT_POLICY_VIOLATION',
  RejectCreditPolicyViolationHard = 'REJECT_CREDIT_POLICY_VIOLATION_HARD',
  RejectUnrecognizedForResidualCreditBalance = 'REJECT_UNRECOGNIZED_FOR_RESIDUAL_CREDIT_BALANCE',
  RejectPartialTransferDelivererInitiatedReject = 'REJECT_PARTIAL_TRANSFER_DELIVERER_INITIATED_REJECT',
  RejectFailReversalReject = 'REJECT_FAIL_REVERSAL_REJECT',
  RejectReclaimReject = 'REJECT_RECLAIM_REJECT',
  RejectMutualFundCleanupReject = 'REJECT_MUTUAL_FUND_CLEANUP_REJECT',
  Accept = 'ACCEPT',
  Accelerate = 'ACCELERATE',
  WaitingOnContraParty = 'WAITING_ON_CONTRA_PARTY',
  WaitingOnNscc = 'WAITING_ON_NSCC',
  SubmitFrRecord = 'SUBMIT_FR_RECORD',
}

// same as recommended action, but no initiate transfer
export enum UserOverrideAction {
  None = 'NONE',
  AcceptAssets = 'ACCEPT_ASSETS',
  AttachAssets = 'ATTACH_ASSETS',
  Reject = 'REJECT',
  Resubmit = 'RESUBMIT',
  AddAsset = 'ADD_ASSET',
  DeleteAsset = 'DELETE_ASSET',
  AdjustAsset = 'ADJUST_ASSET',
  Purge = 'PURGE',
  RejectSsnTaxIdMismatch = 'REJECT_SSN_TAX_ID_MISMATCH',
  RejectAccountTitleMismatch = 'REJECT_ACCOUNT_TITLE_MISMATCH',
  RejectDocumentationNeeded = 'REJECT_DOCUMENTATION_NEEDED',
  RejectAccountFlat = 'REJECT_ACCOUNT_FLAT',
  RejectInvalidAccountNumber = 'REJECT_INVALID_ACCOUNT_NUMBER',
  RejectDuplicate = 'REJECT_DUPLICATE',
  RejectAccountInDistrubutionOrTransfer = 'REJECT_ACCOUNT_IN_DISTRIBUTION_OR_TRANSFER',
  RejectClientRescinded = 'REJECT_CLIENT_RESCINDED',
  RejectMissingAuthorizationSignature = 'REJECT_MISSING_AUTHORIZATION_SIGNATURE',
  RejectCreditPolicyViolation = 'REJECT_CREDIT_POLICY_VIOLATION',
  RejectCreditPolicyViolationHard = 'REJECT_CREDIT_POLICY_VIOLATION_HARD',
  RejectUnrecognizedForResidualCreditBalance = 'REJECT_UNRECOGNIZED_FOR_RESIDUAL_CREDIT_BALANCE',
  RejectPartialTransferDelivererInitiatedReject = 'REJECT_PARTIAL_TRANSFER_DELIVERER_INITIATED_REJECT',
  RejectFailReversalReject = 'REJECT_FAIL_REVERSAL_REJECT',
  RejectReclaimReject = 'REJECT_RECLAIM_REJECT',
  RejectMutualFundCleanupReject = 'REJECT_MUTUAL_FUND_CLEANUP_REJECT',
  Accept = 'ACCEPT',
  Accelerate = 'ACCELERATE',
  WaitingOnContraParty = 'WAITING_ON_CONTRA_PARTY',
  WaitingOnNscc = 'WAITING_ON_NSCC',
  SubmitFrRecord = 'SUBMIT_FR_RECORD',
}

export const AlpsRecommendedActionDisplay: {
  // eslint-disable-next-line
  [key in AlpsRecommendedAction]: string
} = {
  [AlpsRecommendedAction.None]: 'None',
  [AlpsRecommendedAction.AcceptAssets]: 'Accept Assets',
  [AlpsRecommendedAction.AttachAssets]: 'Attach Assets',
  [AlpsRecommendedAction.Reject]: 'Reject',
  [AlpsRecommendedAction.Resubmit]: 'Resubmit',
  [AlpsRecommendedAction.InitiateTransfer]: 'Initiate',
  [AlpsRecommendedAction.AddAsset]: 'Add Asset',
  [AlpsRecommendedAction.DeleteAsset]: 'Delete Asset',
  [AlpsRecommendedAction.AdjustAsset]: 'Adjust Asset',
  [AlpsRecommendedAction.Purge]: 'Purge',
  [AlpsRecommendedAction.RejectSsnTaxIdMismatch]:
    'Reject - SSN Tax ID Mismatch',
  [AlpsRecommendedAction.RejectAccountTitleMismatch]:
    'Reject - Account Title Mismatch',
  [AlpsRecommendedAction.RejectDocumentationNeeded]:
    'Reject - Documentation Needed',
  [AlpsRecommendedAction.RejectAccountFlat]: 'Reject - Account Flat',
  [AlpsRecommendedAction.RejectInvalidAccountNumber]:
    'Reject - Invalid Account Number',
  [AlpsRecommendedAction.RejectDuplicate]: 'Reject - Duplicate',
  [AlpsRecommendedAction.RejectAccountInDistrubutionOrTransfer]:
    'Reject - Account in Distribution or Transfer',
  [AlpsRecommendedAction.RejectClientRescinded]: 'Reject - Client Rescinded',
  [AlpsRecommendedAction.RejectMissingAuthorizationSignature]:
    'Reject - Missing Authorization Signature',
  [AlpsRecommendedAction.RejectCreditPolicyViolation]:
    'Reject - Credit Policy Violation',
  [AlpsRecommendedAction.RejectCreditPolicyViolationHard]:
    'Reject - Credit Policy Violation Hard',
  [AlpsRecommendedAction.RejectUnrecognizedForResidualCreditBalance]:
    'Reject - Unrecognized for Residual Credit Balance',
  [AlpsRecommendedAction.RejectPartialTransferDelivererInitiatedReject]:
    'Reject - Partial Transfer Deliverer Initiated Reject',
  [AlpsRecommendedAction.RejectFailReversalReject]:
    'Reject - Fail Reversal Reject',
  [AlpsRecommendedAction.RejectReclaimReject]: 'Reject - Reclaim Reject',
  [AlpsRecommendedAction.RejectMutualFundCleanupReject]:
    'Reject - Mutual Fund Cleanup Reject',
  [AlpsRecommendedAction.Accept]: 'Accept',
  [AlpsRecommendedAction.Accelerate]: 'Accelerate',
  [AlpsRecommendedAction.WaitingOnContraParty]: 'Waiting on ContraParty',
  [AlpsRecommendedAction.WaitingOnNscc]: 'Waiting on NSCC',
  [AlpsRecommendedAction.SubmitFrRecord]: 'Submit FR',
}

export enum TransferSummary {
  Undefined = 'UNDEFINED',
  Accepted = 'ACCEPTED',
  Rejected = 'REJECTED',
  Error = 'ERROR',
  Pending = 'PENDING',
  PendingNeedsReview = 'PENDING_NEEDS_REVIEW',
}

// eslint-disable-next-line
export const TransferSummaryDisplay: { [key in TransferSummary]: string } = {
  [TransferSummary.Undefined]: 'Undefined',
  [TransferSummary.Accepted]: 'Accepted',
  [TransferSummary.Rejected]: 'Rejected',
  [TransferSummary.Error]: 'Error',
  [TransferSummary.Pending]: 'Pending',
  [TransferSummary.PendingNeedsReview]: 'Pending Needs Review',
}

export interface AcatsSearchDto {
  accountNumber?: string
  acatControlNumber?: string
  createdOnStart?: string
  createdOnEnd?: string
  nsccStatus?: NsccStatus
  processingDirection?: ProcessingDirection
  transferType?: TransferType
  rejectReason?: RejectReason
  transferSummary?: TransferSummary
}

export interface AcatsSearchTransferDto {
  acats: AcatsTransfer[]
}

export interface AcatsTransfer {
  // FEECM-17598: Changed from number to string - control numbers are 18 digits (exceeds JS MAX_SAFE_INTEGER of 16 digits)
  acatControlNumber?: string
  acatKey?: string
  accountNumber?: string
  age?: string
  ageInStatus?: string
  alpsActionReason?: string
  alpsRecommendedAction?: AlpsRecommendedAction
  alpsStatus?: AlpsStatus
  contraAccountNumber?: string
  contraClearingNumber?: number
  contraFirmName?: string
  createdDate?: string
  customerName?: string
  cycle?: number
  isFinal?: boolean
  isScheduled?: boolean
  isSubmitted?: boolean
  lastAction?: AlpsRecommendedAction
  nsccStatus?: NsccStatus
  processingCaseId?: number
  processingDirection?: ProcessingDirection
  rejectReason?: RejectReason
  transferType?: TransferType
  totalAccountValue?: number | 'pending'
  userOverrideAction?: string //"NONE" could be one of the enums
}

export enum PublicStatus {
  New = 'New',
  SentToDeliveringFirm = 'SentToDeliveringFirm',
  ResponseReceived = 'ResponseReceived',
  Approved = 'Approved',
  Complete = 'Complete',
  Rejected = 'Rejected',
  Error = 'Error',
}

export const PublicStatusDisplay: { [key in PublicStatus]: string } = {
  [PublicStatus.New]: 'New',
  [PublicStatus.SentToDeliveringFirm]: 'Sent to Delivering Firm',
  [PublicStatus.ResponseReceived]: 'Response Received',
  [PublicStatus.Approved]: 'Approved',
  [PublicStatus.Complete]: 'Complete',
  [PublicStatus.Error]: 'Error',
  [PublicStatus.Rejected]: 'Rejected',
}

export interface AnonymousStatusDto {
  publicStatus?: PublicStatus
  nsccStatus?: NsccStatus
  created?: string
  lastUpdated?: string
  expectedSettleDate?: string
  errorText?: string
}

export interface RejectTransferResultWebDto {
  acatsControlNumber?: number
  action?: AlpsRecommendedAction
  errors?: ValidationErrorWebDto
}

export enum ErrorCode {
  GeneralError = 'GENERAL_ERROR',
  RequiredValue = 'REQUIRED_VALUE',
  LengthMismatch = 'LENGTH_MISMATCH',
  NotFound = 'NOT_FOUND',
  InvalidValue = 'INVALID_VALUE',
  RangeError = 'RANGE_ERROR',
  AccessDenied = 'ACCESS_DENIED',
}

export const ErrorCodeDisplay: { [key in ErrorCode]: string } = {
  [ErrorCode.GeneralError]: 'General Error',
  [ErrorCode.RequiredValue]: 'Required Value',
  [ErrorCode.LengthMismatch]: 'Length Mismatch',
  [ErrorCode.NotFound]: 'Not Found',
  [ErrorCode.InvalidValue]: 'Invalid Value',
  [ErrorCode.RangeError]: 'Range Error',
  [ErrorCode.AccessDenied]: 'Access Denied',
}

export interface ValidationErrorWebDto {
  errorCode?: ErrorCode
  fieldName?: string
  message?: string
  attemptedValue?: string
}

export interface ResolutionResultDto {
  isScheduled: boolean
  userOverrideAction: UserOverrideAction
  errors: ValidationErrorWebDto[]
}

export interface AlpsAcatDetailV2WebDto {
  acatsControlNumber: number
  processingCaseId: number
  tifId: string
  clientReferenceId: string
  direction: ProcessingDirection | 'UNDEFINED'
  transferType: TransferType
  status: SnapshotStatusWebDto
  nextCycle: string
  previousCycle: string
  created: string
  receiver: DetailAccountInfo
  deliverer: DetailAccountInfo
  errors: ValidationErrorWebDto[]
  requestedAssets: AssetWebDto[]
  deliveringAssets: AssetWebDto[]
  nonDeliverableAssets: AssetWebDto[]
  anonymousStatus: AnonymousStatusDto
  anonymousKey: string
  caseStates: CaseStateDetailsWebDto[]
}

export interface CaseStateDetailsWebDto {
  stateType: string
  recommendation: string
  override: string
  scheduledAt: string
  scheduledBy: string
  submittedAt: string
  cycleDate: string
  reason: string
  comment: string
  scores: CaseStateScoreDetailsWebDto[]
}

export interface CaseStateScoreDetailsWebDto {
  scoreType: string
  result: string
  notes: string
}

export interface AssetWebDto {
  identifiers: AssetIdentifierWebDto[]
  description: string
  quantity: number
  amount: number
  assetSequenceNumber: number
  currency: CurrencyWebDto
  settlingLocation: string
  comment: string
  longShort: string
  assetErrors: StatefulPropertyValueWebDto[]
}

export interface StatefulPropertyValueWebDto {
  propertyIdentifier: string
  value: string
  state: string
  stateId: object // schema only says empty object
}

export interface CurrencyWebDto {
  isoCode: string
  symbol: string
  rate: number
}

export enum AssetIdentifierType {
  CUSIP = 'CUSIP',
  Symbol = 'SYMBOL',
  ISIN = 'ISIN',
  CINS = 'CINS',
  InsuranceContractNumber = 'INSURANCE_CONTRACT_NUMBER',
  MutualFundAccountNumber = 'MUTUAL_FUND_ACCOUNT_NUMBER',
  SEDOL = 'SEDOL',
  CommonNumber = 'COMMON_NUMBER',
  Cash = 'CASH',
  SecurityAdpNumber = 'SECURITY_ADP_NUMBER',
}

export interface AssetIdentifierWebDto {
  type: AssetIdentifierType
  value: string
}

export interface DetailAccountInfo {
  accountTypes: AccountType[]
  accountTitle: string
  primarySsnOrTaxId: string
  secondarySsnOrTaxId: string
  interestedPartySsnOrTaxId: string[]
  assets: AssetWebDto[]
  isMarginAccount: boolean
  correspondentName: string
  accountNumber: string
  participantName: string
  participantNumber: number
}

export enum AccountType {
  '403B' = '403B',
  '401K' = '401K',
  '529Plan' = '529_PLAN',
  '457Plan' = '457_PLAN',
  Agency = 'AGENCY',
  BankCustody = 'BANK_CUSTODY',
  Beneficiary = 'BENEFICIARY',
  BeneficiaryRothIRA = 'BENEFICIARY_ROTH_IRA',
  Corporate = 'CORPORATE',
  Cotrustee = 'COTRUSTEE',
  CustodianUGMA = 'CUSTODIAN_UGMA',
  DirectRollover = 'DIRECT_ROLLOVER',
  CoverdellIRA = 'COVERDELL_IRA',
  Estate = 'ESTATE',
  HealthSavingsAccount = 'HEALTH_SAVINGS_ACCOUNT',
  IRA = 'IRA',
  Joint = 'JOINT',
  MedicalSavingsAccount = 'MEDICAL_SAVINGS_ACCOUNT',
  Other = 'OTHER',
  QualifiedProfitSharingPension = 'QUALIFIED/PROFIT_SHARING/PENSION',
  RothIRA = 'ROTH_IRA',
  SimpleIRA = 'SIMPLE_IRA',
  SARSEP = 'SARSEP',
  Single = 'SINGLE',
  Trust = 'TRUST',
}

//Note the similarity to above AccountType
export enum ContraPartyAccountType {
  '403B' = '403B',
  '401K' = '401K',
  '529_PLAN' = '529_PLAN',
  '757_PLAN' = '757_PLAN',
  Agency = 'AGENCY',
  BankCustody = 'BANK_CUSTODY',
  Beneficiary = 'BENEFICIARY',
  BeneficiaryRothIra = 'BENEFICIARY_ROTH_IRA',
  Corporate = 'CORPORATE',
  CoTrustee = 'CO_TRUSTEE',
  CustodianUgma = 'CUSTODIAN_UGMA',
  DirectRollover = 'DIRECT_ROLLOVER',
  CoverdellIra = 'COVERDELL_IRA',
  Estate = 'ESTATE',
  HealthSavingsAccount = 'HEALTH_SAVINGS_ACCOUNT',
  Ira = 'IRA',
  Joint = 'JOINT',
  MedicalSavingsAccount = 'MEDICAL_SAVINGS_ACCOUNT',
  Other = 'OTHER',
  QualifiedProfitSharingPension = 'QUALIFIED_PROFIT_SHARING_PENSION',
  RothIra = 'ROTH_IRA',
  SimpleIra = 'SIMPLE_IRA',
  Sarsep = 'SARSEP',
  Single = 'SINGLE',
  Trust = 'TRUST',
}

export interface Documents {
  documents: Document[]
}
export interface Document {
  date: string
  description: string
  documentsubtype: string
  documenttype: string
  downloadinfo: {
    downloadUrl: string
    filename: string
    filetype: string
  }
  id: string
  name: string
  previewinfo: {
    downloadUrl: string
    filename: string
    filetype: string
  }
}
export interface SnapshotStatusWebDto {
  action: AlpsRecommendedAction
  alpsRecommendedAction: AlpsRecommendedAction
  isScheduled: boolean
  isSubmitted: boolean
  state: AlpsStatus
  nsccState: NsccStatus | 'TRANSFER_COMPLETE' | 'INITIATE_REQUEST'
  nsccSubState: RejectReason
  rejectReason: RejectReason
  notes: string
  alpsActionReason: string
}

export interface AlpsAsset {
  amount: string
  currency: string
  cusip: string
  description: string
  id: number
  identifier: string
  quantity: string
  sequence: number
  settlingLocation: string
  settlingLocationReason: string
  source: string
  status: string
  symbol: string
}

export interface AlpsAssetMetadata {
  cycle: string
  id: number
  processingDate: string
  rejectReason: string | null
  source: string
  status: string
  systemAction: string | null
}

export interface AlpsStatefulProperty {
  propertyIdentifier: string
  state: string
  stateId: number
  value: string
}

export interface AuditTrail {
  comment: string
  timestamp: string
  type: string
  username: string
}

export enum TransferTypeRejectDto {
  DocumentationNeeded = 'DOCUMENTATION_NEEDED',
  ClientRescinded = 'CLIENT_RESCINDED',
  MissingAuthorizationSignature = 'MISSING_AUTHORIZATION_SIGNATURE',
  CreditPolicyViolated = 'CREDIT_POLICY_VIOLATED',
}

export const TransferTypeRejectDtoDisplay: {
  [key in TransferTypeRejectDto]: string
} = {
  [TransferTypeRejectDto.DocumentationNeeded]: 'Documentation Needed',
  [TransferTypeRejectDto.ClientRescinded]: 'Client Rescinded',
  [TransferTypeRejectDto.MissingAuthorizationSignature]:
    'Missing Authorization Signature',
  [TransferTypeRejectDto.CreditPolicyViolated]: 'Credit Policy Violated',
}

export interface RejectTransferDto {
  reason: TransferTypeRejectDto
  comment: string
}

export enum TransferInitiationCashType {
  Debit = 'DEBIT',
  Credit = 'CREDIT',
}

export const TransferInitiationCashTypeDisplay: {
  [key in TransferInitiationCashType]: string
} = {
  [TransferInitiationCashType.Credit]: 'Credit',
  [TransferInitiationCashType.Debit]: 'Debit',
}

export enum TransferInitiationAssetType {
  Cusip = 'CUSIP',
  Symbol = 'SYMBOL',
  Isin = 'ISIN',
  Cins = 'CINS',
  Sedol = 'SEDOL',
  Cash = 'CASH',
}

export enum TransferInitiationOptionPutType {
  Put = 'PUT',
  Call = 'CALL',
}

export interface TransferInitiationCashWebDto {
  rowId?: string //Used for book keeping and removed prior to submission.
  amount: number
  isoCurrencyCode: string
  type: TransferInitiationCashType
}

export interface TransferInitiationAssetWebDto {
  rowId?: string
  assetType: TransferInitiationAssetType
  identifier?: string
  isoCurrencyCode?: string
  amount?: number
  isShort?: boolean
}

export interface TransferInitiationOptionWebDto {
  symbol: string
  contractDate: string //date-time
  put: TransferInitiationOptionPutType
  strikePrice: number
  isShort: boolean
  amount: number
}

export interface DtcParticipantWebDto {
  participantNumber: string
}

export interface ContraPartyWebDto {
  account: string
  accountTitle: string
  primarySsnOrTaxId: string | null
  secondarySsnOrTaxId: string | null
  accountType: ContraPartyAccountType | ''
  participant: DtcParticipantWebDto
  comment: string
}

export interface TransferInitiationWebDto {
  account: string
  disableAutoSign: boolean
  clientReferenceId: string
  transferType?: TransferInitiationTransferType
  cash?: TransferInitiationCashWebDto[]
  assets?: TransferInitiationAssetWebDto[]
  options?: TransferInitiationOptionWebDto[]
  contraParty: ContraPartyWebDto
  originalControlNumber: number
}

export interface TransferInitiationResultWebDto {
  tifId?: string
  processingCaseId?: number
  errors?: ValidationErrorWebDto[]
}
